import React, { createContext, useContext, useState, useCallback } from 'react';

const MessageContext = createContext();

export const useMessages = () => {
    const context = useContext(MessageContext);
    if (!context) {
        throw new Error('useMessages must be used within a MessageProvider');
    }
    return context;
};

export const MessageProvider = ({ children }) => {
    const [messages, setMessages] = useState([]);

    const addMessage = useCallback(message => {
        const messageWithDefaults = {
            id: `msg-${Date.now()}-${Math.random().toString(36).substr(2, 9)}`,
            timestamp: Date.now(),
            ...message,
        };
        setMessages(prev => [...prev, messageWithDefaults]);
    }, []);

    const clearMessages = useCallback(() => {
        setMessages([]);
    }, []);

    const value = {
        messages,
        setMessages,
        addMessage,
        clearMessages,
    };

    return (
        <MessageContext.Provider value={value}>
            {children}
        </MessageContext.Provider>
    );
};
